module.exports = __webpack_public_path__ + "static/img/expertBg.2f5bc4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expertBg.png
// module id = S8gG
// module chunks = 1